'use client';

import type { ReactNode } from 'react';

import { AuthProvider } from '$lib/app/auth-context';
import { CompanyProvider } from '$lib/app/company-context';
import { SubscriptionProvider } from '$lib/app/subscription-context';
import { ConfirmProvider } from '$lib/ui';

export function AppProviders({ children }: { children: ReactNode }) {
	return (
		<AuthProvider>
			<CompanyProvider>
				<SubscriptionProvider>
					<ConfirmProvider>{children}</ConfirmProvider>
				</SubscriptionProvider>
			</CompanyProvider>
		</AuthProvider>
	);
}
